/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EventGroup } from '@app/events/events-groups/event-group.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventGroupsService } from '@app/events/events-groups/event-groups.service';
import { Logger } from '@app/core';
import { ApiQuery } from '@app/core/http/api-query';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

const log = new Logger('EventGroupsFormComponent');

@UntilDestroy()
@Component({
  selector: 'app-event-groups-form',
  templateUrl: './event-groups-form.component.html',
  styleUrls: ['./event-groups-form.component.scss'],
})
export class EventGroupsFormComponent implements OnInit {
  @Input() eventGroup: EventGroup = null;
  form: FormGroup;
  LaravelModelsEnum = LaravelModelsEnum;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private eventGroupService: EventGroupsService
  ) {}

  ngOnInit() {
    this.createForm();
    this.patchForm();
  }

  save() {
    if (this.eventGroup && this.eventGroup.id) {
      const eventGroup: EventGroup = this.eventGroup.deserialize(this.form.value);
      this.eventGroupService
        .update(eventGroup)
        .pipe(untilDestroyed(this))
        .subscribe((res) => this.modal.close(res));
    } else {
      const eventGroup: EventGroup = new EventGroup().deserialize(this.form.value);
      this.eventGroupService
        .store(eventGroup)
        .pipe(untilDestroyed(this))
        .subscribe((res) => this.modal.close(res));
    }
  }

  test(form: any) {
    log.debug(form);
  }

  private createForm(): void {
    this.form = this.formBuilder.group({
      id: [null],
      name: [null, [Validators.required]],
      web_name: [null],
      founded_year: [null],
      industry_id: [null, [Validators.required]],
      industries: [[], [Validators.required]],
      industry: [null],
      priority_id: [null, [Validators.required]],
      repeat_id: [null, [Validators.required]],
      organizer: [null],
      visitors: [null],
      exhibitors: [null],
      foreign_exhibitors: [null],
      website_url: [null],
      link_exhibitors: [null],
      year_exhibitors: [null],
      venue_id: [null],
      venue: [null],
      active: [false],
      logo: [null],
      new_logo: [null],
      show_to_web: [false],
      tags: [false],
    });
  }

  private patchForm() {
    if (this.eventGroup && this.eventGroup.id) {
      const query = new ApiQuery().addIncludes('industry', 'industries', 'logo', 'tags');
      this.eventGroupService
        .show(this.eventGroup.id, query)
        .pipe(untilDestroyed(this))
        .subscribe((eventGroup: EventGroup) => {
          this.form.patchValue(eventGroup);
        });
    } else if (this.eventGroup) {
      this.form.patchValue(this.eventGroup);
    }
  }
}
